// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3G1w7","title":"style_title__21b3g","discription":"style_discription__20QWQ","body":"style_body__2b3g1","shadowBox":"style_shadowBox__2IXER"};